import { defineMessages } from "react-intl";

export const authorizeStatusMessages = defineMessages({
  full: {
    defaultMessage: "Full",
    id: "F/JMp6",
    description: "authorize status full",
  },
  partial: {
    defaultMessage: "Partial",
    id: "EojeG7",
    description: "authorize status partial",
  },
  none: {
    defaultMessage: "None",
    id: "EoTI4r",
    description: "authorize status none",
  },
});

export const chargeStatusMessages = defineMessages({
  full: {
    defaultMessage: "Full",
    id: "UIM5bq",
    description: "charge status full",
  },
  partial: {
    defaultMessage: "Partial",
    id: "KPmk40",
    description: "charge status partial",
  },
  overcharged: {
    defaultMessage: "Overcharged",
    id: "ZOamBQ",
    description: "charge status overcharged",
  },
  none: {
    defaultMessage: "None",
    id: "dLIeRH",
    description: "charge status none",
  },
});
